/* Copyright (c) 2021-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { ServiceWorkerService } from 'service-worker/lib/service-worker.service';
import { SwMessageType } from 'service-workers/sw.types';
import { RemoteLoggingService } from '../remote-logging/services/remote-logging.service';
import { LoggerSettings } from './logging-types';
import { Logger, LoggingService } from './logging.service';

const loggerName = '[Worker]:';

@Injectable({
    providedIn: 'root'
})
export class WorkerLoggingService {
    private logger: Logger;
    private loggerSettings: LoggerSettings;

    constructor(
        private serviceWorkerService: ServiceWorkerService,
        private loggingService: LoggingService,
        private remoteLoggingService: RemoteLoggingService
    ) {
        this.logger = loggingService.getLogger(loggerName);
    }

    initialize(remoteLogging: boolean, consoleLogging: boolean) {
        this.serviceWorkerService.swLoggingUpdate$.pipe().subscribe((response: any) => {
            this.remoteLoggingService.collectLogString(response.content);
        });

        const loggingLevel = this.loggingService.getLoggingLevel(loggerName);
        this.loggerSettings = {
            remoteLoggingEnabled: remoteLogging,
            consoleLoggingEnabled: consoleLogging,
            loggingLevel,
            remoteLogFunction: null
        };

        // Pass logger settings to service worker
        this.serviceWorkerService.postMessageSw({
            type: SwMessageType.SetLoggerSettings,
            content: JSON.stringify(this.loggerSettings)
        });
    }

    public getLoggerSettings() {
        return this.loggerSettings;
    }
}
